const HAIKU = { label: "Haiku 4.5", tone: null };
const SONNET = { label: "Sonnet 5", tone: "info" };
const OPUS_48 = { label: "Opus 4.8", tone: "primary" };
const OPUS_5 = { label: "Opus 5", tone: "primary-deep" };
const FABLE_5 = { label: "Fable 5", tone: "accent" };
export const PLAN_PRESENTATION = {
    en: {
        // --- MFA (consumer) -----------------------------------------------------
        spark: {
            name: "Spark",
            blurb: "Try it, get hooked",
            badges: [{ slug: "start_here", label: "Start here" }],
            featureGroups: [
                {
                    title: null,
                    items: [
                        "3 starter templates",
                        "Community gallery: view only",
                        "100 MB project workspace",
                        "Help center support",
                    ],
                },
            ],
            modelHighlights: [HAIKU],
            comparisonLeadIn: null,
        },
        explorer: {
            name: "Explorer",
            blurb: "For everyday builders",
            badges: [],
            featureGroups: [
                {
                    title: null,
                    items: [
                        "Full template library (45+)",
                        "Weekly plans for your agents",
                        "Publish agents to the community gallery",
                        "2 GB project workspace",
                    ],
                },
            ],
            modelHighlights: [HAIKU, SONNET],
            comparisonLeadIn: "Everything in Spark, plus:",
        },
        builder: {
            name: "Builder",
            blurb: "The full kit",
            badges: [{ slug: "most_popular", label: "Most popular" }],
            featureGroups: [
                {
                    title: null,
                    items: [
                        "100 runs a day",
                        "Safety approvals before agents act",
                        "10 GB project workspace",
                    ],
                },
            ],
            modelHighlights: [HAIKU, SONNET, OPUS_48, OPUS_5],
            comparisonLeadIn: "Everything in Explorer, plus:",
        },
        frontier: {
            name: "Frontier",
            blurb: "Frontier models, big projects",
            badges: [],
            featureGroups: [
                {
                    title: null,
                    items: [
                        "Fable 5: Anthropic's most capable model",
                        "Priority support",
                        "25 GB project workspace",
                    ],
                },
            ],
            modelHighlights: [HAIKU, SONNET, OPUS_48, OPUS_5, FABLE_5],
            comparisonLeadIn: "Everything in Builder, plus:",
        },
        // --- LYA (education) ----------------------------------------------------
        "classroom-free": {
            name: "Classroom Free",
            blurb: "Try it with a small group",
            badges: [{ slug: "start_here", label: "Start here" }],
            featureGroups: [
                {
                    title: null,
                    items: ["20 runs a day", "3 starter templates", "Class gallery: view only"],
                },
            ],
            modelHighlights: [HAIKU],
            comparisonLeadIn: null,
        },
        classroom: {
            name: "Classroom",
            blurb: "One class, fully equipped",
            badges: [{ slug: "most_popular", label: "Most popular" }],
            featureGroups: [
                {
                    title: null,
                    items: [
                        "200 runs a day",
                        "Connect your tools with MCP",
                        "Student work gallery",
                        "Class-wide safety approvals",
                        "10 GB shared workspace",
                    ],
                },
            ],
            modelHighlights: [HAIKU, SONNET],
            comparisonLeadIn: "Everything in Classroom Free, plus:",
        },
        school: {
            name: "School",
            blurb: "Every classroom, one plan",
            badges: [],
            featureGroups: [
                {
                    title: null,
                    items: [
                        "400 runs a day",
                        "Every model in the standard set",
                        "Connect your tools with MCP",
                        "Priority support",
                        "50 GB shared workspace",
                    ],
                },
            ],
            modelHighlights: [HAIKU, SONNET, OPUS_48, OPUS_5],
            comparisonLeadIn: "Everything in Classroom, plus:",
        },
    },
    es: {
        // --- MFA (consumer) -----------------------------------------------------
        spark: {
            name: "Spark",
            blurb: "Pruébalo y engánchate",
            badges: [{ slug: "start_here", label: "Empieza aquí" }],
            featureGroups: [
                {
                    title: null,
                    items: [
                        "3 plantillas iniciales",
                        "Galería comunitaria: solo ver",
                        "100 MB de espacio de proyectos",
                        "Soporte del centro de ayuda",
                    ],
                },
            ],
            modelHighlights: [HAIKU],
            comparisonLeadIn: null,
        },
        explorer: {
            name: "Explorer",
            blurb: "Para constructores de cada día",
            badges: [],
            featureGroups: [
                {
                    title: null,
                    items: [
                        "Biblioteca completa de plantillas (45+)",
                        "Planes semanales para tus agentes",
                        "Publica agentes en la galería comunitaria",
                        "2 GB de espacio de proyectos",
                    ],
                },
            ],
            modelHighlights: [HAIKU, SONNET],
            comparisonLeadIn: "Todo lo de Spark, y además:",
        },
        builder: {
            name: "Builder",
            blurb: "El kit completo",
            badges: [{ slug: "most_popular", label: "Más popular" }],
            featureGroups: [
                {
                    title: null,
                    items: [
                        "100 ejecuciones al día",
                        "Aprobaciones de seguridad antes de que los agentes actúen",
                        "10 GB de espacio de proyectos",
                    ],
                },
            ],
            modelHighlights: [HAIKU, SONNET, OPUS_48, OPUS_5],
            comparisonLeadIn: "Todo lo de Explorer, y además:",
        },
        frontier: {
            name: "Frontier",
            blurb: "Modelos de frontera, proyectos grandes",
            badges: [],
            featureGroups: [
                {
                    title: null,
                    items: [
                        "Fable 5: el modelo más capaz de Anthropic",
                        "Soporte prioritario",
                        "25 GB de espacio de proyectos",
                    ],
                },
            ],
            modelHighlights: [HAIKU, SONNET, OPUS_48, OPUS_5, FABLE_5],
            comparisonLeadIn: "Todo lo de Builder, y además:",
        },
        // --- LYA (education) ----------------------------------------------------
        "classroom-free": {
            name: "Classroom Free",
            blurb: "Pruébalo con un grupo pequeño",
            badges: [{ slug: "start_here", label: "Empieza aquí" }],
            featureGroups: [
                {
                    title: null,
                    items: ["20 ejecuciones al día", "3 plantillas iniciales", "Galería de clase: solo ver"],
                },
            ],
            modelHighlights: [HAIKU],
            comparisonLeadIn: null,
        },
        classroom: {
            name: "Classroom",
            blurb: "Una clase, totalmente equipada",
            badges: [{ slug: "most_popular", label: "Más popular" }],
            featureGroups: [
                {
                    title: null,
                    items: [
                        "200 ejecuciones al día",
                        "Conecta tus herramientas con MCP",
                        "Galería de trabajos de estudiantes",
                        "Aprobaciones de seguridad para toda la clase",
                        "10 GB de espacio compartido",
                    ],
                },
            ],
            modelHighlights: [HAIKU, SONNET],
            comparisonLeadIn: "Todo lo de Classroom Free, y además:",
        },
        school: {
            name: "School",
            blurb: "Cada aula, un solo plan",
            badges: [],
            featureGroups: [
                {
                    title: null,
                    items: [
                        "400 ejecuciones al día",
                        "Todos los modelos del conjunto estándar",
                        "Conecta tus herramientas con MCP",
                        "Soporte prioritario",
                        "50 GB de espacio compartido",
                    ],
                },
            ],
            modelHighlights: [HAIKU, SONNET, OPUS_48, OPUS_5],
            comparisonLeadIn: "Todo lo de Classroom, y además:",
        },
    },
};
/**
 * Offer notes per plan and locale. V2 quoted a per-student price on the LYA tiers,
 * computed from the student seats of the family/profile model; V5 has no seats, so every
 * paid tier carries the one true claim — annual is ten times monthly, two months free.
 */
export const PLAN_OFFER_NOTES = {
    en: {
        spark: { month: null, year: null },
        explorer: { month: null, year: "Two months free vs monthly" },
        builder: { month: null, year: "Two months free vs monthly" },
        frontier: { month: null, year: "Two months free vs monthly" },
        "classroom-free": { month: null, year: null },
        classroom: { month: null, year: "Two months free vs monthly" },
        school: { month: null, year: "Two months free vs monthly" },
    },
    es: {
        spark: { month: null, year: null },
        explorer: { month: null, year: "Dos meses gratis frente al mensual" },
        builder: { month: null, year: "Dos meses gratis frente al mensual" },
        frontier: { month: null, year: "Dos meses gratis frente al mensual" },
        "classroom-free": { month: null, year: null },
        classroom: { month: null, year: "Dos meses gratis frente al mensual" },
        school: { month: null, year: "Dos meses gratis frente al mensual" },
    },
};
//# sourceMappingURL=plan-presentation.js.map